class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
    }

    /*
      ACCESSIBILITE 26/08/2026, version 2 . Pastilles de carnation dans les
      diapositives masquées.

      LE DÉFAUT. Splide pose aria-hidden="true" sur les diapositives non visibles,
      puis remet tabindex="-1" sur leurs descendants focalisables. Mais seulement
      sur ceux qui correspondent à son option focusableNodes, dont la valeur par
      défaut est 'a, button, textarea, input, select, iframe'. La pastille de carte
      produit est un <span role="button" tabindex="0">, Splide ne la voit jamais.
      La diapositive est donc annoncée masquée aux lecteurs d'écran alors que la
      pastille reste atteignable au clavier.

      POURQUOI CETTE VERSION 2. La version 1, publiée le 26/08 vers 13 h,
      inscrivait un écouteur sur neuf types d'évènements, pour CHAQUE carrousel de
      la page, sans vérifier qu'il contenait des pastilles. Mesure PageSpeed du
      26/08 à 14 h 06 sur /collections/nipply-collection, mobile :
      temps de non réponse 100 ms vers 670 ms, vitesse d'affichage globale
      2,8 s vers 6,1 s, score 56 vers 51.
      Les trois observations concordent : la page collection porte une dizaine de
      carrousels et s'effondre, la fiche produit n'en porte qu'un et ne passe que
      de 60 à 100 ms, l'accueil n'en porte aucun sur ses cartes et ne bouge pas.

      CE QUE CORRIGE LA VERSION 2 :
      1. L'écouteur n'est inscrit QUE si le carrousel contient réellement des
         pastilles. Sur la fiche produit et sur les carrousels de contenu, coût nul.
      2. La liste d'évènements est réduite à ceux qui changent réellement la
         visibilité d'une diapositive. En particulier « resized » est retiré : il
         est déclenché en cascade par le ResizeObserver déjà présent plus bas.

      AUCUN EFFET VISUEL. tabindex ne s'affiche pas, aucune règle CSS du thème ne
      cible .swatch-link:focus, et le clic passe par le gestionnaire délégué de
      product-card-swatches.js, qui lit data-href sans regarder le tabindex.

      RETOUR ARRIÈRE : supprimer ce bloc.
    */
    if (this.querySelector('.swatch-link')) {
      const syncSwatchTabindex = () => {
        try {
          const slides = (this.slider.Components.Elements || {}).slides || [];
          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const swatches = slide.querySelectorAll('.swatch-link');
            if (!swatches.length) continue;
            const value = slide.getAttribute('aria-hidden') === 'true' ? '-1' : '0';
            for (let j = 0; j < swatches.length; j++) {
              if (swatches[j].getAttribute('tabindex') !== value) {
                swatches[j].setAttribute('tabindex', value);
              }
            }
          }
        } catch (e) {
          /* jamais bloquant : l'accessibilité ne doit pas casser le carrousel */
        }
      };

      this.slider.on('moved visible hidden', syncSwatchTabindex);
      syncSwatchTabindex();
    }

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  updateSize() {
    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}